import api from '../config/axiosConfig';

export const SaleService = {
    fetchVentas: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre }) => {
        try {
            const response = await api.get('/ventas/todas', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    fetchVentasAvances: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list }) => {
        try {
            const response = await api.get('/ventas-avances/', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre, list },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentas:', error);
            throw error;
        }
    },
    fetchVentasReported: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list, reported = false }) => {
        try {
            const response = await api.get('/ventas-avances/reported', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre, list, reported },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentasReported:', error);
            throw error;
        }
    },
    fetchVentasInstalado: async ({ token, pagina = 1, pageSize = 20, desde, hasta, dni, nombre, list }) => {
        try {
            const response = await api.get('/ventas/instaladas', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, dni, nombre, list },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentasInstalado:', error);
            throw error;
        }
    },
    exportarVentasInstaladasExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas/exportarVentasInstaladas', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.exportarVentasInstaladasExcel:', error);
            throw error;
        }
    },
    exportarVentasReportadasExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas-avances/exportarVentasReportadas', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.exportarVentasReportadasExcel:', error);
            throw error;
        }
    },
    getStatisticsInstaladas: async ({ token, fechaInicio, fechaFin }) => {
        try {
           
            const response = await api.post(`/ventas/countinstalada`, {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.getStatisticsInstaladas:', error);
            throw error;
        }
    },
    getStatistics: async ({ token, fechaInicio, fechaFin }) => { 
        try {
            const response = await api.post(`/ventas-avances/count`, {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.getStatistics:', error);
            throw error;
        }
    },
    validarCodigo: async (token, codigo) => {
        try {
            const response = await api.get(`/ventas/validar-codigo/${codigo}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data.existe;
        } catch (error) {
            console.error('Error en VentaService.validarCodigo:', error);
            throw error;
        }
    },
    exportarVentasExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas/exportar', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.exportarVentasExcel:', error);
            throw error;
        }
    },
    exportarVentasAvancesExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas-avances/exportar', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.exportarVentasAvancesExcel:', error);
            throw error;
        }
    },
    exportarReporteVentasExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas/exportarReporte', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en VentaService.exportarReporteVentasExcel:', error);
            throw error;
        }
    },
    fetchVentaPorId: async (token, id) => {
        try {
            const response = await api.get(`/ventas/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en VentaService.fetchVentaPorId:', error);
            throw error;
        }
    },
    fetchAvanceVentaPorId: async (token, id) => {
        try {
            const response = await api.get(`/ventas-avances/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en VentaService.fetchAvanceVentaPorId:', error);
            throw error;
        }
    },
    fetchVentasReporte: async ({ token, pagina = 1, pageSize = 20, desde, hasta, nombre, vendedores, estado, regiones }) => {
        try {
            const response = await api.get('/ventas/reporte', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, nombre, vendedores, regiones, estado },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en VentaService.fetchVentasReporte:', error);
            throw error;
        }
    },
    getEstadoVenta: async (token) => {
        try {
            const response = await api.get('/ajustes/estadoventa',
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estadoVenta;
        } catch (error) {
            console.error('Error en VentaService.getEstadoVenta:', error);
            throw error;
        }
    },
};
